// In this Form we are working on updating password when user forget it and this form corespond to thia page :
//http://localhost:3000/reset-password?token= and get the token from url using SearchParams and the new password from user's input.

import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

import { useNavigate } from "react-router-dom";
import { useLogin } from "../../../hooks/useLogin"; // Import the useLogin hook

const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordSuggestions, setPasswordSuggestions] = useState([]);
  const [unSuccessMessage, setUnSuccessMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { changePassword, isLoading } = useLogin();

  const handelUpdateNewPassword = async (e) => {
    e.preventDefault();
    if (passwordStrength !== "strong") {
      setUnSuccessMessage("Please choose a stronger password.");
      return;
    }
    const token = searchParams.get("token");
    if (!newPassword) {
      setUnSuccessMessage("New Password must not be blank.");
      return;
    }
    const response = await changePassword(token, newPassword);

    if (response === "success") {
      setSuccessMessage("Password updated successfully.");
      setUnSuccessMessage("");

      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else {
      setUnSuccessMessage("An unexpected error occurred. Please try again.");
      setSuccessMessage("");
    }
  };
  const checkPasswordStrength = (pwd) => {
    let strength = "strong";
    let suggestions = [];

    if (pwd.length < 8) {
      strength = "weak";
      suggestions.push("Password should be at least 8 characters long.");
    }
    if (!/[A-Z]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Add at least one uppercase letter.");
    }
    if (!/\d/.test(pwd)) {
      strength = "medium";
      suggestions.push("Include at least one number.");
    }
    if (!/[!@#$%^&*]/.test(pwd)) {
      strength = "weak";
      suggestions.push("Use at least one special character (@, #, $,!,...).");
    }

    setPasswordStrength(strength);
    setPasswordSuggestions(suggestions);
  };

  const handlePasswordChange = (e) => {
    const pwd = e.target.value;
    setNewPassword(pwd);
    checkPasswordStrength(pwd);
  };

  return (
    <>
      {successMessage && (
        <div className="message-box" aria-live="polite">
          {successMessage}
        </div>
      )}
      {unSuccessMessage && (
        <div className="error-message-box" aria-live="polite">
          {unSuccessMessage}
        </div>
      )}
      <h2 className="form-header">CHANGE PASSWORD</h2>
      <div className="col-6">
        <Form className="form-box">
          <Form.Group className="mb-3" controlId="formBasicCode">
            <Form.Label className="text-above-box">New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder=""
              onChange={handlePasswordChange}
            />
          </Form.Group>

          <p className={`password-strength ${passwordStrength}`}>
            Password strength: {passwordStrength}
          </p>

          {passwordSuggestions.length > 0 && (
            <>
              <ul className="password-suggestions">
                {passwordSuggestions.map((suggestion, index) => (
                  <li key={index}>{suggestion}</li>
                ))}
              </ul>
            </>
          )}

          <div className="d-grid gap-2">
            <Button
              variant="btn btn-primary login-buttomn"
              type="submit"
              onClick={handelUpdateNewPassword}
            >
              {isLoading ? "Saving..." : "Save"}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default ResetPasswordForm;
